import { useTranslation } from "react-i18next";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import KeyActionPanel, { KeyAction } from "@/shared/ui/KeyActionPanel";
import { setDesignOpenConfirmBuy } from "@/domains/estate/slice";
import useDesignHandlers from "@/domains/estate/hooks/handlers/useDesignHandlers";
import EstateDesignVariantBuyConfirmModalContainer from "@/domains/estate/containers/tablet/tabs/design/EstateDesignVariantBuyConfirmModalContainer";
import KeyCode from "@/assets/constants/key-code";

function EstateDesignVariantPreviewContainer() {
  const { t } = useTranslation("estate");
  const dispatch = useAppDispatch();
  const { closePreviewHandler } = useDesignHandlers();

  const actions = new Map<KeyCode, KeyAction>([
    [
      KeyCode.ESCAPE,
      {
        label: t("estate.design.return"),
        keyName: "ESC",
        className: "font-arial",
        action: () => {
          closePreviewHandler();
        },
        color: "red",
      },
    ],
    [
      KeyCode.G,
      {
        label: t("estate.design.payDesignVariant"),
        keyName: "G",
        className: "font-arial",
        action: () => {
          dispatch(setDesignOpenConfirmBuy(true));
        },
        color: "red",
      },
    ],
  ]);

  return (
    <>
      <EstateDesignVariantBuyConfirmModalContainer />
      <KeyActionPanel actions={actions} name="estate-design-variant-preview" />
    </>
  );
}

export default EstateDesignVariantPreviewContainer;
